import { cn } from '@mntn-dev/ui-utilities'
import type { VirtualItem } from '@tanstack/react-virtual'
import { motion } from 'motion/react'
import type { KeyboardEvent, PropsWithChildren, RefAttributes } from 'react'
import { getVirtualItemProps } from '../../hooks/use-virtualizer.tsx'

export type ScrollItemBaseProps = PropsWithChildren<{
  disabled?: boolean
  label?: string
  onClick?: () => void
  onKeyDown?: (e: KeyboardEvent<HTMLDivElement>) => void
  optionHeight?: number
  selected?: boolean
  virtualItem?: VirtualItem
}> &
  RefAttributes<HTMLDivElement>

export const SelectItemBase = ({
  children,
  disabled,
  label,
  onClick,
  onKeyDown,
  optionHeight,
  ref,
  selected,
  virtualItem,
}: ScrollItemBaseProps) => {
  const isVirtualized = !!virtualItem
  return (
    <motion.div
      // biome-ignore lint/a11y/useSemanticElements: option is not correct html
      role="option"
      tabIndex={-1}
      aria-disabled={disabled}
      aria-label={label}
      aria-selected={selected}
      ref={ref}
      className={cn(
        'flex justify-start items-center p-3 gap-2.5 cursor-pointer not-last:border-b w-full overflow-hidden border-container hover:bg-tertiary',
        {
          'cursor-pointer': !disabled,
        }
      )}
      onKeyDown={onKeyDown}
      initial={{
        backgroundColor: 'rgba(0, 0, 0, 0)',
      }}
      whileHover={
        disabled
          ? undefined
          : {
              backgroundColor: 'rgba(0, 0, 0, 0.2)',
            }
      }
      whileTap={
        disabled
          ? undefined
          : {
              backgroundColor: 'rgba(0, 0, 0, 0.4)',
            }
      }
      onClick={onClick}
      style={
        isVirtualized
          ? {
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: `${optionHeight}px`,
              transform: `translateY(${virtualItem?.start}px)`,
            }
          : undefined
      }
      {...(isVirtualized ? getVirtualItemProps(virtualItem) : {})}
    >
      {children}
    </motion.div>
  )
}
